import React from 'react';
import { BoldButton, BoldLink } from '@bold/web-components-react';

import whatsappFunction from 'utils/whatsappFunction';
import SegmentButton from 'components/website/SegmentButton';

import './title.scss';

const Title = () => {
  const handleSalesSupport = e => {
    e.preventDefault();

    const whatsAppOptions = {
      subject: 'sales',
      from: 'home',
      phone: 'default',
      text: '¡Hola! Me interesa el datáfono Bold. ¿Pueden darme más información por favor?',
    };

    whatsappFunction(whatsAppOptions);
  };

  return (
    <>
      <div className="home-hero-title">
        <h1 className="title-header-bold-blue">Dile sí a</h1>
        <div className="slider">
          <div className="slide slide-1">
            <h1 className="title-header-bold-blue">
              más <span className="color-coral-100"> clientes</span>
            </h1>
          </div>
          <div className="slide slide-2">
            <h1 className="title-header-bold-blue">
              más <span className="color-coral-100"> ventas</span>
            </h1>
          </div>
          <div className="slide slide-3">
            <h1 className="title-header-bold-blue">
              más <span className="color-coral-100"> formas de cobro</span>
            </h1>
          </div>
          <div className="slide slide-4">
            <h1 className="title-header-bold-blue">
              un datáfono <span className="color-coral-100"> propio</span>
            </h1>
          </div>
        </div>
      </div>
      <div className="home-hero-buttons-wrapper">
        <SegmentButton
          event="purchase"
          url="https://tienda.bold.co/"
          isBlank
          isLink
          obj={{
            page_section: 'hero',
            banner_name: 'promo_abril_bold',
          }}
        >
          <BoldButton size="default" color="accent" type="button">
            Comprar
          </BoldButton>
        </SegmentButton>
        <SegmentButton
          event="contactsales"
          obj={{
            page_section: 'hero',
          }}
        >
          <BoldLink href="#" color="accent" strong="true" underline="true" onClick={handleSalesSupport}>
            Contactar Ventas
          </BoldLink>
        </SegmentButton>
      </div>
    </>
  );
};

export default Title;
